<template>
	<div class="seller-address">
		<div class="edit-card">
			<div class="edit-title">{{ editForm.id ? '编辑地址' : '新建地址' }}<span class="count-text">（{{ count }} / {{ maxCount }} 条）</span></div>
			<el-form class="edit-form" label-width="90px" size="small">
				<el-form-item label="收货人">
					<el-input v-model="editForm.name" maxlength="50" show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="收货电话">
					<el-input v-model="editForm.phone" maxlength="20" show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="收货地址">
					<el-input type="textarea" :rows="2" v-model="editForm.address" maxlength="255" show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="默认">
					<el-switch v-model="editForm.is_default" :active-value="1" :inactive-value="0"></el-switch>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" :loading="saving" :disabled="!editForm.id && count >= maxCount" @click="onSave">{{ editForm.id ? '保存修改' : '新增地址' }}</el-button>
					<el-button @click="resetEdit">清空</el-button>
				</el-form-item>
			</el-form>
		</div>
		<el-table :data="list" border style="width: 100%">
			<el-table-column prop="name" label="收货人" align="center" min-width="90px"></el-table-column>
			<el-table-column prop="phone" label="电话" align="center" min-width="120px"></el-table-column>
			<el-table-column prop="address" label="地址" align="center" min-width="220px"></el-table-column>
			<el-table-column label="默认" align="center" width="80px">
				<template slot-scope="scope">{{ scope.row.is_default == 1 ? '是' : '' }}</template>
			</el-table-column>
			<el-table-column label="操作" fixed="right" align="center" width="140px">
				<template slot-scope="scope">
					<div class="operation_i">
						<span @click="openEdit(scope.row)">编辑</span>
						<span @click="onDelete(scope.row)">删除</span>
					</div>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
	import { apiMsg } from './money.js'

	export default {
		name: 'SellerWarehouseAddress',
		data() {
			return {
				list: [],
				count: 0,
				maxCount: 10,
				saving: false,
				editForm: {
					id: '',
					name: '',
					phone: '',
					address: '',
					is_default: 0
				}
			}
		},
		mounted() {
			this.onlist()
		},
		methods: {
			onlist() {
				this.$axios.post('api/cloud_warehouse/address_list', {}).then(res => {
					if (res.data.code === 0) {
						var data = res.data.data || {}
						this.list = data.list || []
						this.count = data.count || 0
						this.maxCount = data.max_count || 10
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					console.log(err)
				})
			},
			openEdit(row) {
				this.editForm = {
					id: row.id,
					name: row.name || '',
					phone: row.phone || '',
					address: row.address || '',
					is_default: Number(row.is_default || 0)
				}
			},
			resetEdit() {
				this.editForm = {
					id: '',
					name: '',
					phone: '',
					address: '',
					is_default: 0
				}
			},
			onSave() {
				if (!String(this.editForm.name || '').trim()) {
					this.$message.warning('请输入收货人')
					return
				}
				if (!String(this.editForm.phone || '').trim()) {
					this.$message.warning('请输入收货电话')
					return
				}
				if (!String(this.editForm.address || '').trim()) {
					this.$message.warning('请输入收货地址')
					return
				}
				var payload = {
					name: this.editForm.name,
					phone: this.editForm.phone,
					address: this.editForm.address,
					is_default: this.editForm.is_default
				}
				if (this.editForm.id) {
					payload.id = this.editForm.id
				}
				this.saving = true
				this.$axios.post('api/cloud_warehouse/address_save', payload).then(res => {
					this.saving = false
					if (res.data.code === 0) {
						this.$message.success(this.editForm.id ? '地址已更新' : '地址已新增')
						this.resetEdit()
						this.onlist()
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.saving = false
					console.log(err)
				})
			},
			onDelete(row) {
				this.$confirm('删除后不可恢复，默认地址会自动补位。', '删除地址', {
					confirmButtonText: '删除',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$axios.post('api/cloud_warehouse/address_delete', { id: row.id }).then(res => {
						if (res.data.code === 0) {
							this.$message.success('已删除')
							if (this.editForm.id == row.id) {
								this.resetEdit()
							}
							this.onlist()
						} else {
							this.$message.error(apiMsg(res))
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {})
			}
		}
	}
</script>

<style scoped lang="less">
	.seller-address {
		padding-bottom: 20px;
	}

	.edit-card {
		background: #fff;
		border: 1px solid #EBEEF5;
		padding: 16px 16px 0;
		margin-bottom: 12px;
	}

	.edit-title {
		font-weight: 600;
		margin-bottom: 8px;
	}

	.edit-form {
		max-width: 560px;
	}

	.count-text {
		color: #909399;
		font-weight: 400;
		margin-left: 8px;
	}
</style>



// WEBPACK FOOTER //
// src/components/seller/warehouse/address.vue